import { cloneDeep } from 'lodash';

const SET_PREORDER_MESSAGE = 'SET_PREORDER_MESSAGE';
const SET_PREORDER_MESSAGE_FALSE = 'SET_PREORDER_MESSAGE_FALSE';

const initialStatePreorderMessage = false;

export default function reducer(state = cloneDeep(initialStatePreorderMessage), action) {
	switch (action.type) {
		case SET_PREORDER_MESSAGE:
			return action.payload;
		case SET_PREORDER_MESSAGE_FALSE:
			return false;
		default:
			return state;
	}
}

export function firePreorderMessage( obj ){
  return {
    type: SET_PREORDER_MESSAGE,
    payload: obj
  }
}

export function clearPreorderMessage(){
  return { type: SET_PREORDER_MESSAGE_FALSE }
}


// WEBPACK FOOTER //
// ./src/modules/preorder_message.js